import React from "react";
import { FormattedMessage } from "react-intl";
import { formatDecimal } from "../../helpers/itemCalculations";
import { useSelector } from "react-redux";

interface ICheckoutBreakdownsMobileProps {
  showTips: boolean;
  amountBreakdowns: any;
  appliedOrderPromotionName: string;
  removeTipFromBreakdown: () => void;
}

const CheckoutBreakdownsMobile = ({
  showTips,
  removeTipFromBreakdown,
  amountBreakdowns,
  appliedOrderPromotionName,
}: ICheckoutBreakdownsMobileProps) => {
  const { currency } = useSelector((state: any) => state.company);
  const { is_tax_inclusive: isMenuTaxInclusive } = useSelector(
    (state: any) => state.menu
  );
  const { discount, riderTip } = useSelector((state: any) => state);
  const { redeemedPoints = 0 } = useSelector((state: any) => state.loyalty);

  return (
    <div className='charges-breakdown'>
      <div className='charge'>
        <FormattedMessage id='global.subtotal' defaultMessage='Subtotal' />
        <p>
          {currency} {formatDecimal(amountBreakdowns.subTotal)}
        </p>
      </div>
      {showTips && riderTip > 0 ? (
        <div className='charge'>
          <p>
            Tip{" "}
            <span
              style={{
                color: "blue",
                textDecoration: "underline",
              }}
              onClick={() => removeTipFromBreakdown()}
            >
              Remove
            </span>
          </p>
          <p>
            {currency} {formatDecimal(amountBreakdowns.tips)}
          </p>
        </div>
      ) : null}
      {discount ? (
        <div className='charge'>
          <p className='label'>{discount.discount_name}</p>
          <p className='value'>
            - {currency} {formatDecimal(discount.discountedAmount)}
          </p>
        </div>
      ) : null}
      {redeemedPoints ? (
        <div className='charge'>
          <p>
            <FormattedMessage id='global.loyalty' defaultMessage='Loyalty' />
          </p>
          <p className='value'>
            - {currency} {formatDecimal(redeemedPoints)}
          </p>
        </div>
      ) : null}
      {amountBreakdowns.surchargeBreakDown.map((surcharge: any, index: any) => {
        return (
          <div className='charge' key={index}>
            <p className='label'>{surcharge.name}</p>
            <p className='value'>
              {currency} {formatDecimal(surcharge.amount)}
            </p>
          </div>
        );
      })}
      {amountBreakdowns.orderPromotionDiscount > 0 ? (
        <div className='charge'>
          <p className='label'>{appliedOrderPromotionName}</p>
          <p className='value'>
            - {currency}{" "}
            {formatDecimal(amountBreakdowns.orderPromotionDiscount)}
          </p>
        </div>
      ) : null}
      {!isMenuTaxInclusive && amountBreakdowns.taxTotal > 0 ? (
        <>
          {amountBreakdowns.taxBreakdown &&
          amountBreakdowns.taxBreakdown.length > 0 ? (
            amountBreakdowns.taxBreakdown.map((tax: any) => {
              return (
                <div className='charge' key={tax.id}>
                  <p className='label'>{`${tax.name} (${tax.rate}%)`}</p>
                  <p className='value'>
                    {currency} {formatDecimal(tax.amount)}
                  </p>
                </div>
              );
            })
          ) : (
            <div className='charge'>
              <p>
                <FormattedMessage id='global.tax' defaultMessage='Tax' />
              </p>
              <p>
                {currency} {formatDecimal(amountBreakdowns.taxTotal)}
              </p>
            </div>
          )}
        </>
      ) : null}
      <div className='charge strong'>
        <p className='label'>
          <FormattedMessage id='global.total' defaultMessage='Total' />
        </p>
        <p>
          {currency} {formatDecimal(amountBreakdowns.total)}
        </p>
      </div>
    </div>
  );
};

export default CheckoutBreakdownsMobile;
